import React, { useRef } from "react";

let FileUploader = ({ Clickable, onFileLoad, file, id, ...rest }) => {
  const inputEl = useRef(null);
  const onClickableClick = () => {
    inputEl.current.click();
  };
  const handleChange = e => {
    const file = e.target.files[0];
    onFileLoad(file, id);
  };
  return (
    <>
      <input
        type="file"
        style={{ display: "none" }}
        ref={inputEl}
        accept={".mp3,.mpeg,.m4a"}
        onChange={handleChange}
      />
      {Clickable(onClickableClick, file, rest)}
    </>
  );
};

export default FileUploader;
